module.exports = __webpack_public_path__ + "static/media/Nota Aderezos con mayonesa.0b7bdf56.webp";